var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    className: "alert",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.alert .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#CDD0D4;}\n\t.alert .st1{fill:#74797D;}\n\t.alert .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#74797D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,6.3l-5.9,9.9c-0.1,0.2-0.2,0.5-0.2,0.8c0,0.3,0.1,0.5,0.2,0.8c0.1,0.2,0.3,0.4,0.6,0.6 c0.2,0.1,0.5,0.2,0.8,0.2h11.8c0.3,0,0.5-0.1,0.8-0.2c0.2-0.1,0.4-0.3,0.6-0.6c0.1-0.2,0.2-0.5,0.2-0.8c0-0.3-0.1-0.5-0.2-0.8 l-5.9-9.9C13.2,6,13,5.8,12.8,5.7c-0.2-0.1-0.5-0.2-0.8-0.2c-0.3,0-0.5,0.1-0.8,0.2C11,5.8,10.8,6,10.6,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.9,19H6.1c-0.4,0-0.7-0.1-1-0.3c-0.3-0.2-0.6-0.4-0.8-0.8c-0.2-0.3-0.3-0.7-0.3-1c0-0.4,0.1-0.7,0.3-1 L10.2,6c0.2-0.3,0.4-0.6,0.8-0.7C11.3,5.1,11.6,5,12,5c0.4,0,0.7,0.1,1,0.3c0.3,0.2,0.6,0.4,0.8,0.7l5.9,9.9 c0.2,0.3,0.3,0.7,0.3,1c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.4,0.6-0.8,0.8C18.6,18.9,18.3,19,17.9,19z M11.1,6.5l-5.9,9.9 C5,16.5,5,16.7,5,16.9c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.2,0.3,0.4,0.4C5.7,18,5.9,18,6.1,18h11.8c0.2,0,0.4,0,0.5-0.1 c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.3,0.1-0.5c0-0.2,0-0.4-0.1-0.5l-5.9-9.9c-0.1-0.2-0.2-0.3-0.4-0.4C12.4,6,12.2,6,12,6 c-0.2,0-0.4,0-0.5,0.1C11.3,6.2,11.2,6.4,11.1,6.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.3,15.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5 c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2C11.4,15.9,11.3,15.7,11.3,15.5L11.3,15.5z M11.3,9.9 c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5v2.8c0,0.2-0.1,0.4-0.2,0.5 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5L11.3,9.9L11.3,9.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.2578352863ade139f921ab6156cd0d1e.svg";
export { ForwardRef as ReactComponent };